import { gql } from '@apollo/client'
import { orderFieldsQuery } from '../../queries/order/query'

/**
 * Get's the string for `createOrder` mutation.
 * This mutation places the cart as an order and returns it.
 * @internal
 */

/*
 * Two arguments the live signature accepts are deliberately not declared here.
 *
 * `skipAddon: Boolean = false` — left at its default, which means *not*
 * declared, because the CREATE_ORDER add-on is the tenant integration. It is
 * what calls the client's own system and what sets `WAITING_CALLBACK` when it
 * has `hasCallback`, and `WAITING_CALLBACK` is the mechanism selector the
 * confirmation flow branches on. Sending `skipAddon: true` would bypass the
 * tenant entirely and make every order look like the no-confirmation case.
 *
 * `data: OrderInput` — omitted, because there is nothing to send. Server-side
 * it is a pure override bag (`{ ...newOrder, ...data }` in
 * `getOrderSplitter.ts`), every one of its ten fields is optional, and
 * cinnamon has no value for any of them that the order does not already carry.
 * Declaring a variable nothing sets would put an argument on the wire that
 * says "override nothing", which is what omitting it already says. A future
 * need for `source` or `notes` is then a visible change rather than a filled-in
 * blank.
 *
 * `sessionUid` is `ID!` here, unlike the `order` query's optional one — there
 * is no unscoped branch for a falsy session to fall into, so this is
 * `useGetOrders`' situation rather than `useGetOrderDetail`'s. The caller
 * guards it all the same: no session means no cart to place.
 */
const createOrderMutation = gql`
  mutation CreateOrder($storefrontName: String!, $sessionUid: ID!) {
    createOrder(storefrontName: $storefrontName, sessionUid: $sessionUid) {
      ${orderFieldsQuery}
    }
  }
`

export default createOrderMutation
